import { useLocalization } from '@ais-ui/locale-management';
import { Badge, Button, FormDescription, Label } from '@ais-ui/ui-core';
import { ROUTES } from '../../../routes';
import { useNavigate } from 'react-router';
import { useAuth } from '@ais-ui/auth';
import React from 'react';
import { PiDeviceMobile } from 'react-icons/pi';

const TwoFactorDisabled = () => {
  const { messages } = useLocalization();

  const navigate = useNavigate();

  const handleEnableTwoFactorClick = () => {
    navigate(ROUTES.MULTIFACTOR.AUTHENTICATED.path);
  };
  return (
    <div className="flex flex-col justify-center items-center w-full border rounded-lg p-4 space-y-6">
      <div className="space-y-2">
        <h4 className="text-md font-medium text-center">
          {messages.settingsAuthenticationTwoFactorNotEnabledSubtitle}
        </h4>
        <p className="text-sm text-center">
          {messages.settingsAuthenticationTwoFactorNotEnabledDescription}
        </p>
      </div>
      <Button onClick={handleEnableTwoFactorClick}>
        {messages.settingsAuthenticationEnableTwoFactorButtonText}
      </Button>
    </div>
  );
};

const TwoFactorEnabled = () => {
  const { messages } = useLocalization();

  return (
    <div className="flex flex-col justify-center items-center w-full space-y-4">
      <div className="flex flex-row items-center justify-between border rounded-lg p-4">
        <PiDeviceMobile className=" h-8 w-8 self-start mr-1"></PiDeviceMobile>
        <div className="space-y-2">
          <div className="flex justify-between w-full">
            <Label className="text-base">
              {messages.settingsAuthenticationTwoFactorEnabledAppTile}
            </Label>
            <Badge>
              {messages.settingsAuthenticationTwoFactorEnabledBadge}
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground">
            {messages.settingsAuthenticationTwoFactorEnabledDescription}
          </p>
        </div>
      </div>
    </div>
  );
};

const TwoFactorAzure = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full border rounded-lg p-4 space-y-6">
      <div className="space-y-2">
        <h4 className="text-md font-medium text-center">
          You're logged in with Azure SSO
        </h4>
        <p className="text-sm text-center">
          You cannot enable two-factor authentication while logged in with Azure
        </p>
      </div>
    </div>
  );
};

export const MultiFactor = () => {
  const { messages } = useLocalization();

  const { twoFactorEnabled, authMethod } = useAuth();

  return (
    <div className="w-full space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsAuthenticationTwoFactorTitle}
        </h3>
      </div>
      {authMethod === 'azure' && <TwoFactorAzure />}
      {authMethod !== 'azure' && twoFactorEnabled && <TwoFactorEnabled />}
      {authMethod !== 'azure' && !twoFactorEnabled && <TwoFactorDisabled />}
    </div>
  );
};
